export default "__VITE_ASSET__c61daa3c__"